import { prop } from 'lodash/fp';

import { FETCH } from '@/constants/action-types';
import { makeAsyncMutationTypes } from '@/utils';
import { crmAxios } from '@/utils/Axios';

const { FAILURE, REQUEST, SUCCESS } = makeAsyncMutationTypes(FETCH);

const endpoints = [
  'vlplabels',
  'lines',
  'contactstatuses',
  'questionstatuses',
  'technicalissuetypes',
  'blockedemailaddresses',
  'vlpbannerenabled',
];

const fetchMetadataEndpoint = (endpoint) =>
  crmAxios({
    url: `/Metadata/${endpoint}`,
  }).then(prop('data'));

export default {
  fetch({ commit }) {
    commit(REQUEST);

    return Promise.all(endpoints.map(fetchMetadataEndpoint))
      .then(
        ([
          vlplabels,
          lines,
          contactStatuses,
          questionStatuses,
          technicalIssueTypes,
          blockedEmailAddresses,
          vlpbannerenabled,
        ]) =>
          commit(SUCCESS, {
            vlplabels,
            lines,
            contactStatuses,
            questionStatuses,
            technicalIssueTypes,
            blockedEmailAddresses,
            vlpbannerenabled,
          }),
      )
      .catch((error) => commit(FAILURE, error));
  },
};
